<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <ik-data-table
      ref="table"
      :model="model"
      :required-date-value="currentDate"
      :use-action="false"
      :use-default-action="false"
      :use-select="false"
      entity-name="VoucherUsed"
      icon="mdi-cards"
    >
      <template #footer="{tableItems}">
        <v-card
          :class="!$vuetify.breakpoint.lgAndUp ? 'px-4' : 'px-6'"
          class="py-3 mr-4 text-body-2"
          color="grey lighten-3 black--text"
          dark
          outlined
        >
          {{ $t('totalAmount') }}：{{ tableItems.reduce((sum, it) => sum + parseFloat(it.amount), 0) | priceDisplay }}
        </v-card>
      </template>
    </ik-data-table>
  </div>
</template>

<script>
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import UsedVoucher from '@/model/dataLayer/api/bills/UsedVoucher'

export default {
  name: 'VoucherUsed',
  components: {
    IkDataTable
  },
  props: {
    currentDate: {}
  },
  data () {
    return {
      model: UsedVoucher
    }
  },
  watch: {
    '$parent.dateRange': {
      handler: function (val) {
        console.log(val, 'val')
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
  }
}
</script>

<style scoped>

</style>
